module.exports = __webpack_public_path__ + "static/media/SCB-FRAUEN_logo.a9d80821.png";